import React, { useEffect, useRef, useState } from 'react';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';

import MemberCard, { getPartyColor } from '../landing-page/MemberCard';
import { ReactComponent as HouseMap } from '../../images/househex2020.svg';
import { ReactComponent as SenateMap } from '../../images/senatehex2020.svg';

const useStyles = makeStyles((theme) => ({
	map: {
		marginLeft: 0,
		marginRight: 0,
		marginTop: 40,
		width: '100%',
		height: 620
	},
	buttondDiv: {
		position: 'relative',
		top: '6vh',
		margin: 'auto',
		width: '35%'
	},
	buttonDefault: {
      outline: 'none!important',
      color: '#767676',
      fontFamily: 'Graphik',
      fontSize: 20,
	  fontWeight: 600,
	  borderBottom: '4px solid white'                                                              
  	},
	buttonSelected: {
      outline: 'none!important',
      color: '#333333',
      fontFamily: 'Graphik',
      fontSize: 20,
	  fontWeight: 600,
	  borderBottom: '4px solid #F9A51A'                                                              
	},
	paper: {
		width: 200
	} 
}));

const HOUSETYPE = "House";
const SENATETYPE = "Senate";

const handlePopoverOpen = (event, anchorEl, setAnchorEl) => {

	if (event.target.parentElement.id === "mapDiv" || event.target.parentElement.id === "map") {
		//console.log("DN Event Target", event.target.parentElement.id);
		setAnchorEl(null);
	} else if (event.target.parentElement.id) {
		//console.log("Set Anchor Element->", event.target.parentElement.id);
		if (event.target.parentElement.id !== "mouse-over-popover") {
			setAnchorEl(event.target.parentElement);
		}
		//if (event.target.parentElement.id === "mouse-over-popover") {
		//	setAnchorEl(null);
		//}
	} else {
		//console.log("Setting anchor to null");
		//console.log("Event->", event.target);
		//console.log("Set Anchor Target Null->", event.target);
		//console.log("Set Anchor Path Null->", event.path);
		//setAnchorEl(null);
	}
}

const handlePopoverClose = ((setAnchorEl) => {
	console.log("Closing Popover");
    setAnchorEl(null);
});

const setStateColors = ((mapRef, memberMap, mouseClickFunc) => {
	if (mapRef && memberMap) {
		const SVGElements = Object.values(mapRef.current.children);

		SVGElements.forEach(SVGElement => {
			if (SVGElement && (SVGElement.id.length === 3 || SVGElement.id.length === 4)) {
				const member = memberMap[SVGElement.id];
				if (member) {
					SVGElement.style.fill = getPartyColor(member);
					SVGElement.onclick = mouseClickFunc;
				} else {
					SVGElement.style.fill = "grey";
					console.log("Could not find Member for district: ", SVGElement.id);
				}
			}
		});
	}
});

const getMemberMap = ((memberList) => {
	let members = {}; 
	
	memberList.forEach(member => {
		if (member.positions[0].stateDistrictCode) {
			const memberCode = member.positions[0].stateDistrictCode.replace("-", '');
			members[memberCode] = member;
		}
	});
	return members;
});

const getMemberCard = ((memberMap, stateCode) => {
	if (memberMap && stateCode) {
		let member = memberMap[stateCode.id];
		if (member) {
			return <MemberCard {...member} />;
		}
	}
	return null;
});

const MapCard = (props) => {
	const {memberList, mapType = HOUSETYPE} = props;
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const mapRef = useRef(null);
	const open = Boolean(anchorEl);
	const houseMap = (<HouseMap
					ref={mapRef}
					id="map" 
					className={classes.map}
				/>);
	const senateMap = (<SenateMap
					ref={mapRef}
					id="map" 
					className={classes.map}
				/>);
	const map = (mapType === HOUSETYPE) ? houseMap: senateMap;
	const memberMap = getMemberMap(memberList);
	const mouserClickFunc = (event) => handlePopoverOpen(event, anchorEl, setAnchorEl);
	const mouseLeaveFunc = ()=> handlePopoverClose(setAnchorEl);
	
	useEffect(() => {
		setStateColors(mapRef, memberMap, mouserClickFunc);
	}, [memberList, mapType]); 

	return (
		<React.Fragment>
		<div id="mapDiv" >
			{map}
			<Popover
				id="mouse-over-popover"
				className={classes.popover}
				classes={{
					paper: classes.paper
				}}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={mouseLeaveFunc}
				disableRestoreFocus
			>
				{getMemberCard(memberMap, anchorEl)}
			</Popover>
		</div>
		</React.Fragment>
	)
}

export default MapCard;